import { toast } from "react-toastify";
import { addUnit, removeUnit } from "./unitSlice";
import Repo from "../../Repository/Repo";

export const CreateUnit = async (companyCode, title, dispatch) => {
  let { data } = await Repo.units({
    request: {
      method: "saveCategory",
      data: {
        company_code: companyCode,
        category: title,
      },
    },
  });
  if (data.response.data.categoryStatus == "successful") {
    toast.configure();
    toast.success("Unit Added Successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    dispatch(removeUnit(title));
    toast.configure();
    toast.error("Unit not added", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};

export const deleteUnit = async (companyCode, title, dispatch) => {
  let { data } = await Repo.units({
    request: {
      method: "deleteCategory",
      data: {
        company_code: companyCode,
        category: title,
      },
    },
  });
  if (data.response.data.categoryStatus == "successful") {
    toast.configure();
    toast.success("Deleted Successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    dispatch(addUnit(title));
    toast.configure();
    toast.error("Unit not added", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};
